// Internal Dependencies
import { fetchCodersAction } from './action-creator';
import { firebaseRef } from '../../config/constants';

// Local variables
const Coders = firebaseRef.child('coders');

let allCoders = [];
let totalCoders = 0;

// Action Definitions
export const fetchCoders = () => (dispatch) => {
  allCoders = [];

  Coders.on('value', (snapshot) => {
    totalCoders = Object.keys(snapshot.val()).length;
  });

  return Coders.orderByChild('firstName').on('child_added', (snapshot) => {
    allCoders.push(snapshot.val());
    if (allCoders.length === totalCoders) {
      dispatch(fetchCodersAction(allCoders));
    }
  });
};

export default {
  fetchCoders,
};



/** WEBPACK FOOTER **
 ** ./src/state/actions/coders-actions.js
 **/